import { batchMenus } from "Application/data/sidebar.data.js";
import { menu } from "../../../../data/sidebar.data";

const Logs = () => import("Modules/manufacturing/logs/views/Logs");
const LogsFormOld = () => import("Modules/manufacturing/logs/views/LogsFormOld");
const LogsForm = () => import("Modules/manufacturing/logs/views/LogsForm");

export default {
    children: [
        {
            path: "logs",
            name: "logs",
            component: Logs,
            meta: {
                requiresAuth: true,
                title: "lang.logs",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
        {
            path: "batch_line/logs/form/hourly_operation_log",
            name: "logs_form_hourly_operation_log",
            component: LogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.LogsForm",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
        {
            path: "batch_line/logs/form/furnace_check_sheet",
            name: "log_form_furnace_checklist",
            component: LogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.LogsForm",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
        {
            path: "batch_line/logs/form/paint_process_check_sheet",
            name: "log_form_paint_process_checklist",
            component: LogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.LogsForm",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
        {
            path: "batch_line/logs/form/honing_process_check_sheet",
            name: "log_form_honing_process_checklist",
            component: LogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.LogsForm",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
        {
            path: "batch_line/logs/form/tempering_furnace_check_sheet",
            name: "log_form_tempering_furnace_check_sheet",
            component: LogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.LogsForm",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
        {
            path: "batch_line/logs/form/vacuum_washer_check_list",
            name: "log_form_vacuum_washer_check_list",
            component: LogsForm,
            meta: {
                requiresAuth: true,
                title: "lang.LogsForm",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["logs.read"],
                menu: batchMenus,
            },
        },
    ],
};
